import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";

const InfoDialog = ({ open, close }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t('myevents.infodialog.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText >
          {t('myevents.infodialog.content')} 
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>{t('dialog.gotit.button')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default InfoDialog;
